import { composeValidators } from '@reliance/forms-js/lib/validation';
import React, { ChangeEventHandler } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import FormGroup from 'react-bootstrap/FormGroup';
import Row from 'react-bootstrap/Row';
import { Field } from 'react-final-form';

export enum InputType {
  button = 'button',
  checkbox = 'checkbox',
  color = 'color',
  date = 'date',
  datetimeLocal = 'datetime-local',
  email = 'email',
  file = 'file',
  hidden = 'hidden',
  image = 'image',
  month = 'month',
  number = 'number',
  password = 'password',
  radio = 'radio',
  range = 'range',
  reset = 'reset',
  search = 'search',
  submit = 'submit',
  tel = 'tel',
  text = 'text',
  time = 'time',
  url = 'url',
  week = 'week',
}

type TextInputProps = {
  name: string
  label?: string|JSX.Element
  id?: string
  placeholder?: string
  validationRules?: any[]
  type?: InputType
  helperText?: string
  onChange?: ChangeEventHandler
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  disabled?: boolean
}

type InlineTextInputProps = TextInputProps & {
  labelCols: number
}

export const TextInput: React.FC<TextInputProps> = (props) =>
  <Field
    name={props.name}
    validate={composeValidators(props.validationRules || [])}>
    {({ input, meta }) => (
      <FormGroup>
        {props.label &&
          <label>{props.label}</label>
        }
        <input
          id={props.id}
          placeholder={props.placeholder}
          className={`form-control ${meta.touched && meta.error ? 'has-error' : ''}`}
          disabled={meta.submitting || props.disabled === true}
          type={props.type}
          {...input}
          onChange={(e) => {
            input.onChange(e);
            props.onChange?.(e);
          }}
          onBlur={(e) => {
            input.onBlur(e);
            props.onBlur?.(e);
          }}
        />
        {meta.error && meta.touched ? (
          <span className="help-block has-error">{meta.error}</span>
        ) : props.helperText ? (
          <span className="help-block text-muted">{props.helperText}</span>
        ) : null}
      </FormGroup>
    )}
  </Field>

export const InlineTextInput: React.FC<InlineTextInputProps> = (props) =>
  <Field
    name={props.name}
    validate={composeValidators(props.validationRules || [])}>
    {({ input, meta }) => (
      <Form.Group as={Row}>
        <Form.Label column sm={props.labelCols}>{props.label}</Form.Label>
        <Col>
          <input
            id={props.id}
            placeholder={props.placeholder}
            className={`form-control ${meta.touched && meta.error ? 'has-error' : ''}`}
            disabled={meta.submitting || props.disabled === true}
            type={props.type}
            {...input}
            onChange={(e) => {
              input.onChange(e);
              props.onChange?.(e);
            }}
            onBlur={(e) => {
              input.onBlur(e);
              props.onBlur?.(e);
            }}
          />
          {meta.error && meta.touched ? (
            <span className="help-block has-error">{meta.error}</span>
          ) : props.helperText ? (
            <span className="help-block text-muted">{props.helperText}</span>
          ) : null}
        </Col>
      </Form.Group>
    )}
  </Field>